import { z } from 'zod'
import { formItemSchema } from './form-item'

export const inputTextSchema = formItemSchema.extend({
  type: z.literal('input-text'),
  clearable: z.boolean().optional(),
})

export type InputTextSchema = z.infer<typeof inputTextSchema>
